import {
    Tag,
    message,
    Layout,
    ConfigProvider,
    Breadcrumb,
    Spin,
    Table,
    DatePicker,
    Select,
    AutoComplete,
    Button,
    Drawer,
    Form,
    Col,
    Row,
    Input,
    Checkbox,
    Switch,
    InputNumber,
    Tabs
} from 'antd';
import esES from 'antd/lib/locale/es_ES';
import React, {useState} from 'react';
import {useEffect} from 'react';
import reqwest from 'reqwest';
import moment from 'moment';
import 'antd/dist/antd.css';
import './index.css';
import MyMenu from '../../components/Menu';
import Column from 'antd/lib/table/Column';
import {getToken, getUser} from '../../Utils/common';
import {useHistory} from "react-router-dom";
import PatientProgress from "../../components/PatientProgress";
import config from '../../config'

const {Content, Sider, Header} = Layout;
const {RangePicker} = DatePicker;
const {Option} = Select;
const { TabPane } = Tabs;

moment.locale('es');

const columns = [{
    title: 'Hora',
    dataIndex: 'appointment_at', //render: (text, record, index) => { return <Moment format="hh:mm" date={record.appointment_at}></Moment>}
}, {
    title: 'Paciente', //dataIndex: 'appointment',
    render: (text, record, index) => {
        let _pacients = [];
        record.appointments.forEach(element => {
            //console.log("paciente en turno");
            //console.log(element);
            let color = "blue"
            if (element.is_about_shift) {
                color = "red"
            }

            _pacients.push(<Tag color={color}
                                key={element.id}> {element.pacient.name} {element.pacient.last_name} </Tag>)
        })
        return _pacients
    }
},]

function Appointments() {
    const history = useHistory();
    const [collapsed, setCollapsed] = useState(false);
    const [active, setActive] = useState(0);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [filters, setFilters] = useState('&search=');

    const [appointmentsData, setAppointmentsData] = useState([]);
    const [loadingList, setLoadingList] = useState(false);
    const [profesionals, setProfesionals] = useState([]);
    const [fetchingProfesionals, setFetchingProfesionals] = useState(false);
    const [profesionalSelected, setProfesionalSelected] = useState([])
    const [dateSelected, setDateSelected] = useState(moment())

    const [profesionalName, setProfesionalName] = useState('')
    const [dateToPrint, setDateToPrint] = useState('')

    const [fechaSelected, setFechaSelected] = useState("")
    const [profesionalListed, setProfesionalListed] = useState(0)

    const [visibleSearch, setVisibleSearch] = useState(false)

    const [disabled, setDisabled] = useState(true)
    const [disabledDelete, setDisabledDelete] = useState(true)

    const [disabledSave, setDisabledSave] = useState(true)
    const [visible, setVisible] = useState();
    const [loadingSaveButton, setLoadingSaveButton] = useState(false);
    const [loadingDeleteButton, setLoadingDeleteButton] = useState(false);
    const [spinning, setSpinning] = useState(false);

    const [appointmentform] = Form.useForm();
    const [formTurno] = Form.useForm(); // TODO: rename

    const [profesionalWorkingHours, setProfesionalWorkingHours] = useState([])
    const [options, setOptions] = useState([]);
    const [autocompleteProfesionalOptions, setAutocompleteProfesionalOptions] = useState([]);

    const [autoCompleteText, setAutoCompleteText] = useState("");
    const [pagination, setPagination] = useState({
        current: 1, pageSize: 50,
    });

    const [showOverShifts, setShowOverShifts] = useState(true)
    const [isProfessional, setIsProfessional] = useState(() => {
        const user = getUser()
        let _is_profesional = null
        for (const group in user.groups) {
            console.log(user.groups[group])
            if (user.groups[group] == "profesional") {
                console.log("Is a professional")
                _is_profesional = user.id
            }
        }
        return _is_profesional
    })

    useEffect(() => {
        //fetch({'pagination': pagination, 'filters': filters})
        //fetchProfesionals("")
    }, []);

    const onCollapse = collapsed => {
        //console.log(collapsed);
        setCollapsed((prevCollapsed) => {
            return !prevCollapsed
        });
    };

    const fetchProfesionals = (params = {}) => {
        setFetchingProfesionals(true);
        setProfesionals([]);


        let search = "";
        if (params) search = `?search=${params}`

        if (search === "") search = "?limit=100&offset=100"

        if (isProfessional) {
            console.log("ES PROFESIONAL!!")
            search = isProfessional
        }

        reqwest({
            url: `${config.api_url}/profesionals/${search}`, method: 'get', type: 'json', headers: {
                'Authorization': `Token ${getToken()}`,
            }
        })
            .then(data => {
                //console.log("PARAMS IN profesional FETCH");
                //console.log(params);
                //console.log(data);

                let ops = []
                if (!isProfessional) {
                    ops = data.results.map((values) => {
                        //console.log("Values del search");
                        //console.log(values);
                        return {
                            value: values.id, label: `${values.name} ${values.last_name} (${values.id})`
                        }
                    })
                } else {
                    ops = [{
                        value: isProfessional, label: `${data.name} ${data.last_name}`
                    }]
                }
                setAutocompleteProfesionalOptions(ops);
            }).catch((errorInfo) => {
            setLoading(false);
            if (errorInfo.status == 401) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('user');
                history.push('/login');
            } else message.error(`Ha ocurrido un error al intentar obtener los profesionales.\nStatus: ${errorInfo.status}\nDetalle: ${errorInfo.responseText}`);
        });
    };


    const get_profesional_working_hours = (profesional_id, day) => {
        //console.log("Getting working hours");
        //console.log(profesional_id);

        reqwest({
            url: `${config.api_url}/profesionalworkingdays/?profesional_id=${profesional_id}&day_name=${day}`,
            method: 'get',
            type: 'json',
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        }).then(data => {
            setProfesionalWorkingHours(() => data.results);
        })
    }


    const init_dummy_appointment = (appointment) => {
        appointment.motive = ''
        appointment.modality = ''
        appointment.attended = ''
        appointment.present = ''
        appointment.debt_amount = ''
        appointment.payment_method = ''
    }

    const fetchAppointments = (params = {}) => {
        setLoadingList(true);
        setData([])

        let offset = '';
        if (params.pagination.current > 1) offset = `&offset=${params.pagination.current - 1}`

        let direction = "";
        let order = "";
        if (params.sortField) {
            if (params.sortOrder === "descend") direction = "-";
            order = `&ordering=${direction}${params.sortField}`;
        }
        order = '&ordering=appointment_at'

        const filter_query = `&profesional=${params.filters.pacient_profesional}&appointment_start=${moment(params.filters.appointment_start).format('YYYY-MM-DD 00:00')}&appointment_end=${moment(params.filters.appointment_start).format('YYYY-MM-DD 23:59')}&show_over_shifts=${params.filters.show_over_shifts}`;
        //const filter_query = `&profesional=${params.filters.pacient_profesional}&appointment_start=${moment(params.filters.appointment_start).format('YYYY-MM-DD 00:00')}&appointment_end=${moment(params.filters.appointment_end).format('YYYY-MM-DD 23:59')}`;

        setDateToPrint(moment(params.filters.appointment_start).format('DD-MM-YYYY'))

        reqwest({
            url: `${config.api_url}/appointments/scheduler?limit=${params.pagination.pageSize}${offset}${filter_query}${order}`,
            method: 'get',
            type: 'json',
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        }).then(data => {
            setLoadingList(false);
            //get_profesional_working_hours(params.filters.pacient_profesional, moment(params.filters.appointment_start).format('dd'));
            //console.log("profesional hours");
            //console.log(profesionalWorkingHours);

            //Grid
            //let working_hours_table = []

            const theader_hack = {
                "id": "XXXX",
                "appointment_at": "Hora",
                "pacient": 0,
                "pacient_name": "Paciente",
                "pacient_last_name": "",
                "profesional": 0,
                "profesional_name": "Profesional",
                "profesional_last_name": "",
                "present": "XXXX",
                "attended": "XXXX",
                "pacient_phone": "Tel ppal.",
                "pacient_alternative_phone1": "Tel Sec.",
                "pacient_medical_insurance__name": "Obra Social",
                "pacient_medical_id": "Afiliado Nro.",
                "modality": "Tipo Atencion",
                "motive": "Motivo",
                "pacient_copago": "XXXX",
                "debt_amount": "Debe",
                "payment_method": "Met. Pago",
                "detail": null,
                "is_over_shift": false
            }
            let all_appointments = [theader_hack]
            //let all_appointments = []
            /*profesionalWorkingHours.forEach((val, ind, arr) => {
              let hours_diff = moment(val.hour_to, "HH:mm:ss").diff(moment(val.hour_from, "HH:mm:ss"), 'hours')
              //console.log("Amount of hours")
              //console.log(hours_diff)
              let hour_from = moment(val.hour_from, "HH:mm:ss")
              let intervals_iterations = 2
              let intervals_minutes = 30
              if (val.over_shifts){
                intervals_iterations = 4
                intervals_minutes = 15
              }*/


            //for (let hour=0; hour<hours_diff*intervals_iterations+1; hour++){
            //  let found = false;
            data.results.forEach((element) => {
                console.log(element)
                //if (moment(element.appointment_at).format("HH:mm") == hour_from.format("HH:mm")){
                element.appointment_at = moment(element.appointment_at).format("HH:mm")
                if (!element.id && element.motive != 'SE') {
                    init_dummy_appointment(element)
                }
                //all_appointments.push(element);
                //found = true
                //}
            })
            //if (!found){
            //all_appointments.push({appointment_at: hour_from.format("HH:mm")})
            //}
            //hour_from.add(intervals_minutes, 'minutes')
            //}
            //})

            setLoadingList(false)
            all_appointments.push(...data.results)
            setData(all_appointments);

        }).catch((errorInfo) => {
            setLoadingList(false);
            if (errorInfo.status == 401) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('user');
                history.push('/login');
            } else message.error(`Ha ocurrido un error al intentar obtener los turnos.\nStatus: ${errorInfo.status}\nDetalle: ${errorInfo.responseText}`);
        });
    };

    const fetch_by_id = (id = {}) => {
        setVisibleSearch(false)
        setLoading(true);
        setSpinning(true);
        reqwest({
            url: config.api_url + '/appointments/' + id, method: 'get', type: 'json', headers: {
                'Authorization': `Token ${getToken()}`,
            }
        }).then(data => {
            console.log("Appointment DATA")
            console.log(data)
            formTurno.setFieldsValue(data);
            setVisible(true);
            setSpinning(false);
            setDisabledDelete(false)
            setDisabledSave(false)
            //(data);
        }).catch((errorInfo) => {
            setLoading(false);
            if (errorInfo.status == 401) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('user');
                history.push('/login');
            } else message.error(`Ha ocurrido un error al intentar obtener el turno.\nStatus: ${errorInfo.status}\nDetalle: ${errorInfo.responseText}`);
        });
        ;
    };

    const handleOnChangeProfesional = value => {

        // setProfesionals([])
        setFetchingProfesionals(false)
        //console.log("Selected profesional");
        //console.log(value);

        if (value) {
            setProfesionalSelected(value);
            if (dateSelected) setDisabled(false)
        } else {
            setDisabled(true)
            setProfesionalSelected(value);
        }
    }

    const onPrintAppointment = () => {
        window.print()
    }

    const onPrintPami = () => {
        const search_filters = appointmentform.getFieldsValue();
        const appointment_start = moment(search_filters.appointment_range).format('YYYY-MM-DD 00:00');
        const appointment_end = moment(search_filters.appointment_range).format('YYYY-MM-DD 23:59');
        const pacient_profesional = search_filters.profesionalId;
        fetch(`${config.api_url}/appointments/download_pami_file/?appointment_start=${appointment_start}&appointment_end=${appointment_end}&profesional=${pacient_profesional}&show_over_shifts=${showOverShifts}`, {
            method: 'get', headers: {
                'Authorization': `Token ${getToken()}`,
            }
        })
            .then(response => response.blob())
            .then(blob => {
                const filename = `pami_${moment(search_filters.appointment_range).format('DD_MM_YYYY')}_prof_${pacient_profesional}`
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                a.click();
                a.remove();  //afterwards we remove the element again
            })
            .catch((error) => alert(error))
    }

    const onSearchAppointment = (value) => {

        let search_filters = appointmentform.getFieldsValue();

        let filters = {}
        setFechaSelected(moment(search_filters.appointment_range).format("YYYY-MM-DD"))
        setProfesionalListed(search_filters.profesionalId)

        filters['appointment_start'] = search_filters.appointment_range;
        filters['appointment_end'] = moment(filters.appointment_range).format('YYYY-MM-DD 23:59');
        filters['pacient_profesional'] = search_filters.profesionalId;
        filters['show_over_shifts'] = showOverShifts;

        // let in_days = appointmentform.getFieldValue('appointment_days')
        /*let in_days = 1

        if (!in_days){
          console.log("No estaba seteado");
          appointmentform.setFieldsValue({appointment_days: 0})
        }

        if (value === 'next'){
          appointmentform.setFieldsValue({appointment_days: appointmentform.getFieldValue('appointment_days') + 7})
        }
        else if (value === 'previous'){
          if (in_days <= 0){
            appointmentform.setFieldsValue({appointment_days: 0})
          }
          else{
            appointmentform.setFieldsValue({appointment_days: appointmentform.getFieldValue('appointment_days') - 7})
          }
        }

        let search_filters = appointmentform.getFieldsValue();

        console.log(search_filters);

        let filters = {}

        let start_date_filter = null;
        let end_date_filter = null;

        //if (!search_filters.appointment_days){
        if (in_days == 0){
          start_date_filter = moment(search_filters.appointment_range)
          end_date_filter = moment(search_filters.appointment_range).format('YYYY-MM-DD 23:59')
          filters['appointment_start'] = search_filters.appointment_range;
          filters['appointment_end'] = moment(filters.appointment_range).format('YYYY-MM-DD 23:59');
        }
        else{
          console.log( "desde " + in_days);

          //start_date_filter = moment(search_filters.appointment_range).add(search_filters.appointment_days, 'days')
          //end_date_filter = moment(search_filters.appointment_range).add(search_filters.appointment_days, 'days')
          start_date_filter = moment(search_filters.appointment_range).add(in_days, 'days')
          end_date_filter = moment(search_filters.appointment_range).add(in_days, 'days')

          filters['appointment_start'] = start_date_filter.startOf('week').format('YYYY-MM-DD 00:00');
          filters['appointment_end'] = end_date_filter.endOf('week').format('YYYY-MM-DD 23:59');
        }

        //console.log(start_date_filter);
        //filters['appointment_start'] = start_date_filter.startOf('week').format('YYYY-MM-DD 00:00');
        //filters['appointment_end'] = end_date_filter.endOf('week').format('YYYY-MM-DD 23:59');
        filters['pacient_profesional'] = search_filters.profesionalId;*/

        fetchAppointments({
            pagination, 'filters': filters,
        });
    }

    const fetchPacients = (params) => {
        reqwest({
            url: `${config.api_url}/pacients/?search=${params}&status=A`, method: 'get', type: 'json', headers: {
                'Authorization': `Token ${getToken()}`,
            }
        }).then(data => {
            /*console.log("PARAMS IN FETCH");
            console.log(params);
            console.log(data);*/

            let ops = data.results.map((values) => {
                /*console.log("Values del search");
                console.log(values);
                console.log(profesionalSelected);*/
                // TODO filtrar en back por profesional asignado
                //if (profesionalSelected === values.id){
                return {
                    value: values.id, label: `${values.name} ${values.last_name} (${values.document})`
                }
                //}
            })
            setOptions(ops);
        }).catch((errorInfo) => {
            setLoading(false);
            if (errorInfo.status == 401) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('user');
                history.push('/login');
            } else message.error(`Ha ocurrido un error al intentar obtener los pacientes.\nStatus: ${errorInfo.status}\nDetalle: ${errorInfo.responseText}`);
        });
    };

    const handleSearch = (value) => {
        fetchPacients(value)
    }

    const handleProfesionalSearch = (value) => {
        fetchProfesionals(value)
    }

    const onSelectPacientSearch = (value, option) => {
        formTurno.setFieldsValue({pacient: value})
        formTurno.setFieldsValue({pacient_search: option.label})
        setDisabledSave(false)
    }

    const onSelectProfesional = (value, option) => {
        setProfesionalName(option.label)
        appointmentform.setFieldsValue({profesional: value})
        appointmentform.setFieldsValue({profesionalId: value})
        appointmentform.setFieldsValue({profesional_search: option.label})
        if (value) {
            if (dateSelected) {
                setDisabled(false)
            }
        }
    }

    const onChangePacient = (value) => {
        console.log(value)
        if (!value) {
            setDisabledSave(true)
            setDisabledDelete(true)
            formTurno.setFieldsValue({pacient: ''})
            formTurno.setFieldsValue({pacient_search: ''})
        }
    }

    const onChangeProfesional = (value) => {
        console.log(value)
        setData([])
        if (!value) {
            setDisabled(true)
            formTurno.setFieldsValue({pacient: ''})
            formTurno.setFieldsValue({pacient_search: ''})
        }
    }

    const update_appointment = (appointment = {}) => {
        //console.log(appointment);

        setLoadingSaveButton(true);
        let url = "";
        let method = "";

        if (appointment.id > 0) {
            url = config.api_url + '/appointments/' + appointment.id + '/';
            method = 'patch';
        } else {
            url = config.api_url + '/appointments/';
            method = 'post';
        }
        reqwest({
            url: url, method: method, type: 'json', data: appointment, headers: {
                'Authorization': `Token ${getToken()}`,
            }
        }).then(data => {
            setLoadingSaveButton(false);
            message.success("Actualizacion correcta")

            let search_filters = appointmentform.getFieldsValue();
            /*console.log('DATA')
            console.log(data)*/

            if (method == 'post') {
                // setVisible(false)
                formTurno.setFieldsValue(data);
                setVisibleSearch(false)
                setDisabledDelete(false)
            }

            let filters = {}
            filters['appointment_start'] = search_filters.appointment_range;
            filters['appointment_end'] = moment(filters.appointment_range).format('YYYY-MM-DD 23:59');
            filters['pacient_profesional'] = search_filters.profesionalId;
            fetchAppointments({pagination, 'filters': filters})
        })
            .catch(errorInfo => {

                setLoadingSaveButton(false);
                if (errorInfo.status == 401) {
                    sessionStorage.removeItem('token');
                    sessionStorage.removeItem('user');
                    history.push('/login');
                } else {
                    //console.log(errorInfo);
                    const error_detail_obj = JSON.parse(errorInfo.responseText);
                    let error_detail_txt = "";
                    Object.entries(error_detail_obj).forEach(([k, v]) => {
                        //console.log(k);
                        error_detail_txt = `${error_detail_txt}${k}\n`;
                        v.forEach((value, i, a) => {
                            error_detail_txt = `${error_detail_txt}(${value})\n`;
                            //console.log(value);
                        })
                        error_detail_txt = `${error_detail_txt}\n`;
                    });
                    message.error(`Ha ocurrido un error al intentar guardar el turno.\nStatus: ${errorInfo.status}\nDetalle: ${error_detail_txt}`);
                }
            });
    };

    const delete_appointment = (appointment = {}) => {
        //console.log(appointment);

        setLoadingDeleteButton(true);
        let url = "";
        let method = "";

        url = config.api_url + '/appointments/' + appointment.id + '/';
        method = 'delete';

        reqwest({
            url: url, method: method, type: 'json', data: appointment, headers: {
                'Authorization': `Token ${getToken()}`,
            }
        }).then(data => {
            setLoadingDeleteButton(false);
            message.success("Se ha eliminado correctamente")

            let search_filters = appointmentform.getFieldsValue();

            formTurno.setFieldsValue({"id": 0})
            formTurno.setFieldsValue({pacient: ''})
            formTurno.setFieldsValue({pacient_search: ''})
            setVisible(false)

            let filters = {}
            filters['appointment_start'] = search_filters.appointment_range;
            filters['appointment_end'] = moment(filters.appointment_range).format('YYYY-MM-DD 23:59');
            filters['pacient_profesional'] = search_filters.profesionalId;
            fetchAppointments({pagination, 'filters': filters})
        })
            .catch(errorInfo => {

                setLoadingSaveButton(false);
                if (errorInfo.status == 401) {
                    sessionStorage.removeItem('token');
                    sessionStorage.removeItem('user');
                    history.push('/login');
                } else {
                    //console.log(errorInfo);
                    const error_detail_obj = JSON.parse(errorInfo.responseText);
                    let error_detail_txt = "";
                    Object.entries(error_detail_obj).forEach(([k, v]) => {
                        //console.log(k);
                        error_detail_txt = `${error_detail_txt}${k}\n`;
                        v.forEach((value, i, a) => {
                            error_detail_txt = `${error_detail_txt}(${value})\n`;
                            //console.log(value);
                        })
                        error_detail_txt = `${error_detail_txt}\n`;
                    });
                    message.error(`Ha ocurrido un error al intentar eliminar el turno.\nStatus: ${errorInfo.status}\nDetalle: ${error_detail_txt}`);
                }
            });
    };

    const handleClick = (e) => {
        console.log(e);
    }

    const onDateChange = (value) => {
        setData([])
        if (value) {
            if (profesionalSelected.length > 0) {
                console.log(profesionalSelected)
                setDisabled(false)
                setDateSelected(true)
            }
        } else {
            setDisabled(true)
            setDateSelected(false)
        }
    }

    const showDrawer = (record = 0) => {
        if (record.id == 'XXXX') {
            return
        }
        if (record.id > 0) {
            fetch_by_id(record.id)
        } else {
            //console.log(record.appointment_at)
            let over_shift = false
            const minutes = record.appointment_at.split(":")[1]
            /*console.log("minutos")
            console.log(minutes)*/
            if (minutes !== "30" && minutes !== "00") {
                //console.log("Es sobreturno")
                over_shift = true
            }
            const fecha_turno = moment(`${fechaSelected} ${record.appointment_at}:00`).add(3, "hours").format('YYYY-MM-DDTHH:mm:ss')
            formTurno.setFieldsValue({
                'appointment_at': fecha_turno,
                'profesional': profesionalListed,
                'attended': "NA",
                "present": "NA",
                "modality": "P",
                "motive": "CA",
                "is_over_shift": over_shift,
                "pacient": "",
                "debt_amount": "",
                "pacient_copago": "N",
            });
            setVisibleSearch(true)
            setVisible(true);
            setDisabledSave(true)
            setDisabledDelete(true)

        }
    }

    function onClose() {
        //console.log("Closing drawer");
        formTurno.setFieldsValue({"id": 0, "pacient_search": ""})
        setVisible(false);
    }

    function onSave() {
        console.log("Saving data in drawer");
        console.log(formTurno.getFieldsValue())
        update_appointment(formTurno.getFieldsValue());
    }

    function onDelete() {
        console.log("Deleting appointment");
        console.log(formTurno.getFieldsValue())
        delete_appointment(formTurno.getFieldsValue());

    }

    const onChangeOverShifts = (value) => {
        setShowOverShifts(value)
    }

    return (<>
        <ConfigProvider locale={esES}>
            <Layout style={{minHeight: '100vh'}}>
                <Sider collapsible collapsed={collapsed} onCollapse={onCollapse} className="no-print">
                    <div className="logo"/>
                    <MyMenu active={active}/>
                </Sider>
                <Layout className="site-layout">
                    <Header/>
                    <Content style={{margin: '0 16px'}}>
                        <Breadcrumb style={{position: "relative", margin: '16px 0'}} className="no-print">
                            <Breadcrumb.Item>Home</Breadcrumb.Item>
                            <Breadcrumb.Item>Agenda</Breadcrumb.Item>
                        </Breadcrumb>
                        <Form
                            form={appointmentform}
                            layout="vertical" hideRequiredMark
                            className="no-print"
                        >
                            <Row gutter={16}>
                                <Col span={8}>
                                    <Form.Item
                                        name="profesional_search"
                                        label="Profesional"
                                    >
                                        <AutoComplete
                                            dropdownMatchSelectWidth={252}
                                            options={autocompleteProfesionalOptions}
                                            onSelect={onSelectProfesional}
                                            onChange={onChangeProfesional}
                                            onSearch={handleProfesionalSearch}
                                        >
                                            <Input placeholder="Seleccione un profesional"
                                                   value={autoCompleteText}/>
                                        </AutoComplete>
                                    </Form.Item>
                                </Col>
                                <Col span={4}>
                                    <Form.Item
                                        name="profesionalId"
                                        label="profesionalId"
                                        hidden
                                    >
                                        <Input hidden/>
                                    </Form.Item>
                                </Col>
                                <Col span={4}>
                                    <Form.Item
                                        name="appointment_range"
                                        label="Fecha"
                                    >

                                        <DatePicker defaultValue={moment()} format={"DD/MM/YYYY"}
                                                    onChange={onDateChange}/>
                                    </Form.Item>
                                </Col>
                                <Col span={4}>
                                    <Form.Item
                                        name="hide_over_shift"
                                        label="ST"
                                    >
                                        <Switch defaultChecked={true} size={"small"}
                                                onChange={onChangeOverShifts}></Switch>
                                    </Form.Item>
                                </Col>
                                <Col span={4}>
                                    <Form.Item
                                        name="appointment_range"
                                        label=" "
                                    >
                                        <Button onClick={onSearchAppointment} type="primary" loading={loadingList}
                                                disabled={disabled}> Filtrar </Button>
                                        <Button onClick={onPrintAppointment} type="primary"
                                                disabled={disabled}> Ficha Profesional </Button>
                                        <Button onClick={onPrintPami} type="primary" disabled={disabled}> Ficha
                                            PAMI </Button>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                        <div className="print-only">
                            <h1>Profesional: {profesionalName} - {dateToPrint}</h1>
                        </div>
                        <Table
                            id="appointments-table"
                            size="small"
                            showSizeChanger
                            rowClassName={(record) => {
                                /* console.log(record)
                                if (record.id == 'XXXX') {
                                  console.log("Es el thead")
                                }*/
                            }}
                            rowKey={record => record.id}
                            onRow={(record, rowIndex) => {
                                let id = ""
                                // console.log(record);

                                return {
                                    onClick: event => {
                                        if (record.motive != "SE") {
                                            showDrawer(record)
                                        }
                                    },
                                }
                            }}
                            dataSource={data}
                            pagination={false}
                        >
                            <Column
                                title="Hora"
                                dataIndex="appointment_at"
                            />
                            <Column
                                title="Paciente"
                                render={(text, record, index) => {
                                    // Special Event
                                    if (record.motive == 'SE') {
                                        return `${record.detail}`
                                    }

                                    if (record.pacient_name || record.pacient_last_name) {
                                        return `${record.pacient_name} ${record.pacient_last_name}`
                                    }
                                }}
                            />
                            <Column
                                title="Asistio"
                                render={(text, record, index) => {
                                    if (record.present === 'NA') {
                                        return `-`
                                    }
                                    if (record.present === 'A') {
                                        return `No`
                                    }
                                    if (record.present === 'P') {
                                        return `Si`
                                    }
                                    if (record.present === 'AA') {
                                        return `No c/aviso`
                                    }
                                    if (record.present === 'XXXX') {
                                        return `Asistio`
                                    }
                                }}
                            />
                            <Column
                                title="Atendido"
                                // TODO: funciones common/utils
                                render={(text, record, index) => {
                                    if (record.attended === 'NA') {
                                        return `-`
                                    }
                                    if (record.attended === 'N') {
                                        return `No`
                                    }
                                    if (record.attended === 'Y') {
                                        return `Si`
                                    }
                                    if (record.attended === 'XXXX') {
                                        return `Atendido`
                                    }
                                }}
                            />
                            <Column
                                title="Tipo Atencion"
                                dataIndex="modality"
                            />
                            <Column
                                title="Tel. Ppal."
                                dataIndex="pacient_phone"
                            />
                            <Column
                                title="Tel. Sec."
                                dataIndex="pacient_alternative_phone1"
                            />
                            <Column
                                title="Obra Social"
                                dataIndex="pacient_medical_insurance__name"
                            />
                            <Column
                                title="Afiliado Nro."
                                dataIndex="pacient_medical_id"
                            />
                            <Column
                                title="Motivo"
                                dataIndex="motive"
                            />
                            <Column
                                title="Copago"
                                dataIndex="pacient_copago"
                                render={(text, record, index) => {
                                    if (record.pacient_copago === 'Y') {
                                        return `Si`
                                    } else if (record.pacient_copago === 'N') {
                                        return `No`
                                    }
                                    if (record.pacient_copago === 'XXXX') {
                                        return `Copago`
                                    }
                                }}
                            />
                            <Column
                                title="Debe"
                                dataIndex="debt_amount"
                            />
                            <Col
                                title="Met. Pago"
                                dataIndex="payment_method"
                            />
                        </Table>
                        <Drawer
                            title="Turno"
                            width={"60%"}
                            onClose={onClose}
                            visible={visible}
                            bodyStyle={{paddingBottom: 80}}
                            footer={<div
                                style={{
                                    textAlign: 'right',
                                }}
                            >
                                {/*<Button onClick={onClose} style={{marginRight: 8}}>
                      Cancelar
                    </Button>*/}
                                <Button type={"danger"} onClick={onDelete} loading={loadingDeleteButton}
                                        disabled={disabledDelete} style={{marginRight: 8}}>
                                    Eliminar
                                </Button>
                                <Button onClick={onSave} type="primary" loading={loadingSaveButton}
                                        disabled={disabledSave}>
                                    Guardar
                                </Button>
                            </div>}
                        >
                            <Tabs>
                                <TabPane tab="Turno" key="5">
                                    <Spin spinning={spinning}>
                                        <Form
                                            form={formTurno}
                                            layout="vertical" hideRequiredMark
                                        >
                                            <Row gutter={16}>
                                                <Col span={16}>
                                                    <Form.Item
                                                        name="pacient_search"
                                                        label="Pacientes"
                                                        style={visibleSearch === true ? {display: "inline"} : {display: "none"}}
                                                    >
                                                        <AutoComplete
                                                            dropdownMatchSelectWidth={252}
                                                            style={visibleSearch === true ? {display: "inline"} : {display: "none"}}
                                                            options={options}
                                                            onSelect={onSelectPacientSearch}
                                                            onChange={onChangePacient}
                                                            onSearch={handleSearch}
                                                        >
                                                            <Input placeholder="Seleccione un paciente"
                                                                   value={autoCompleteText}/>
                                                        </AutoComplete>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={4}>
                                                    <Form.Item
                                                        name="pacient"
                                                        label="pacient"
                                                        hidden
                                                    >
                                                        <Input hidden defaultValue={formTurno.pacient}/>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={16}>
                                                <Col span={8}>
                                                    <Form.Item
                                                        name="present"
                                                        label="Asistio"
                                                        rules={[{
                                                            required: true, message: 'Por favor seleccione si asistio'
                                                        }]}
                                                    >
                                                        <Select placeholder="Por favor seleccione una opcion"
                                                                defaultValue={formTurno.present}>
                                                            <Option value="NA">-</Option>
                                                            <Option value="P">Si</Option>
                                                            <Option value="A">No</Option>
                                                            <Option value="AA">No c/aviso</Option>
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8}>
                                                    <Form.Item
                                                        name="attended"
                                                        label="Atendido"
                                                        rules={[{
                                                            required: true,
                                                            message: 'Por favor seleccione si fue atendido'
                                                        }]}
                                                    >
                                                        <Select placeholder="Por favor seleccione una opcion"
                                                                defaultValue={formTurno.attended}>
                                                            <Option value="NA">-</Option>
                                                            <Option value="Y">Si</Option>
                                                            <Option value="N">No</Option>
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8}>
                                                    <Form.Item
                                                        name="id"
                                                        label="id"
                                                        hidden
                                                    >
                                                        <Input hidden defaultValue={formTurno.id}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8}>
                                                    <Form.Item
                                                        name="appointment_at"
                                                        label="appointment_at"
                                                        hidden
                                                    >
                                                        <Input hidden defaultValue={formTurno.appointment_at}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8}>
                                                    <Form.Item
                                                        name="profesional"
                                                        label="profesional"
                                                        hidden
                                                    >
                                                        <Input hidden defaultValue={formTurno.profesional}/>
                                                    </Form.Item>
                                                    <Form.Item
                                                        name="is_over_shift"
                                                        label="sobreturno"
                                                        hidden
                                                    >
                                                        <Input hidden defaultValue={formTurno.is_over_shift}/>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={16}>
                                                <Col span={8}>
                                                    <Form.Item
                                                        name="modality"
                                                        label="Modalidad"
                                                        rules={[{
                                                            required: true, message: 'Por favor seleccione la modalidad'
                                                        }]}
                                                    >
                                                        <Select placeholder="Por favor seleccione una opcion"
                                                                defaultValue={formTurno.modality}>
                                                            <Option value="P">Presencial</Option>
                                                            <Option value="O">Online</Option>
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8}>
                                                    <Form.Item
                                                        name="motive"
                                                        label="Motivo"
                                                        rules={[{
                                                            required: true, message: 'Por favor seleccione un motivo'
                                                        }]}
                                                    >
                                                        <Select placeholder="Por favor seleccione una opcion"
                                                                defaultValue={formTurno.motive}>
                                                            <Option value="CA">Consulta</Option>
                                                            <Option value="AD">Admision</Option>
                                                            <Option value="RA">Readmision</Option>
                                                            <Option value="RE">Receta</Option>
                                                            <Option value="TN">Test Neuro</Option>
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={16}>
                                                <Col span={16}>
                                                    <Form.Item
                                                        name="detail"
                                                        label="Detalle Motivo"
                                                    >
                                                        <Input.TextArea/>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={16}
                                                 style={formTurno.getFieldValue('pacient_copago') === 'Y' ? {display: "inline"} : {display: "none"}}
                                            >
                                                <Col span={8}>
                                                    <Form.Item
                                                        name="debt_amount"
                                                        label="Debe"
                                                    >
                                                        <InputNumber addonBefore="$" style={{width: 120,}}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8}>
                                                    <Form.Item
                                                        name="payment_method"
                                                        label="Método de pago"
                                                        rules={[{
                                                            required: true, message: 'Por favor seleccione una opción'
                                                        }]}
                                                    >
                                                        <Select placeholder="Por favor seleccione una opción"
                                                                defaultValue={formTurno.payment_method}>
                                                            <Option value="NA">-</Option>
                                                            <Option value="FT">Efectivo</Option>
                                                            <Option value="MP">Mercado Pago</Option>
                                                            <Option value="TR">Transferencia</Option>
                                                            <Option value="OT">Otro</Option>
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </Spin>
                                </TabPane>
                                <TabPane tab="Hist. Clínica"
                                         key="4"
                                         // disabled={!isProfessional}
                                >
                                    <PatientProgress key={formTurno.getFieldValue('pacient_id')}
                                                     patient_id={formTurno.getFieldValue('pacient')}
                                                     professional_id={isProfessional}
                                    />
                                </TabPane>
                            </Tabs>
                        </Drawer>
                    </Content>
                </Layout>
            </Layout>
        </ConfigProvider>
    </>);
}

export default Appointments;
